<template>
  <v-container fluid>
    <v-card class="pa-6 elevation-3">
      <v-card-title class="text-h6 font-weight-bold text-uppercase">
      Tela de configuração do sistema
      </v-card-title>

      <v-divider class="my-2"></v-divider>

      <v-list two-line>
        <v-list-item
          v-for="(option, index) in configuracaoMenu"
          :key="index"
          class="py-3 option-item"
          :class="{ 'mobile-view': $vuetify.breakpoint.mobile }"
        >
          <v-list-item-content>
            <v-list-item-title class="text-body-1 font-weight-bold">
              {{ option.titulo }}
            </v-list-item-title>
            <v-list-item-subtitle class="text-body-2 pt-2">
              {{ option.descricao }}
            </v-list-item-subtitle>
          </v-list-item-content>

          <v-list-item-action class="mobile-action">
            <v-switch
              v-model="option.status"
              :label="option.status ? 'Ativado' : 'Desativado'"
              inset
              @change="updateConfiguracao(option)"
              class="ma-2"
              color="primary"
            ></v-switch>
          </v-list-item-action>
        </v-list-item>
      </v-list>
    </v-card>
    <GlobalSnackbar ref="snackbar"/>
  </v-container>
</template>

<script>
import axios from '../../../plugins/axios'
const localStorage = require('local-storage')

export default {

  data() {
    return {
      idInstituicao: localStorage.get('i_id'),
      configuracaoMenu: []
    }
  },
  methods: {
    async getConfiguracaoMenu() {
      try {
        const response = await axios.get('/configuracao-menu/buscar/' + this.idInstituicao)
        this.configuracaoMenu = response.data

        const filteredData = response.data.map(item => ({
          idConfiguracao: item.idConfiguracao,
          idInstituicao: item.idInstituicao,
          titulo: item.titulo,
          chave: item.chave,
          status: item.status
        }))
        localStorage.set('configuracaoMenu', filteredData)
      } catch (error) {
        console.error(error)
        this.$refs.snackbar.mostrar("Erro ao carregar configurações!", "error", "top");
      }
    },
    async updateConfiguracao(option) {
      try {
        const response = await axios.post('/configuracao-menu/atualizar', {
          ...option,
          titulo: option.titulo || option.chave.replace('_', ' ').replace(/([A-Z])/g, ' $1').trim()
        })
       
        const filteredData = response.data.configuracoes.map(item => ({
          idConfiguracao: item.idConfiguracao,
          idInstituicao: item.idInstituicao,
          titulo: item.titulo,
          chave: item.chave,
          status: item.status
        }))
        localStorage.set('configuracaoMenu', filteredData)
        
        this.configuracaoMenu = response.data.configuracoes;
          this.$refs.snackbar.mostrar("Configurações atualizadas com sucesso!", "success", "top");
      } catch (error) {
        console.error(error)
        this.$refs.snackbar.mostrar("Erro ao atualizar configurações!", "error", "top");
      }
    }
  },

  created() {
    this.getConfiguracaoMenu();
  }
}
</script>

<style scoped>
.option-item {
  transition: all 0.3s ease;
}

.mobile-view {
  padding: 16px 8px !important;
}

.mobile-action {
  margin-left: 16px !important;
}

@media screen and (max-width: 600px) {
  .v-list-item__title {
    font-size: 1rem !important;
    line-height: 1.5rem !important;
  }
  
  .v-list-item__subtitle {
    font-size: 0.9rem !important;
    line-height: 1.4rem !important;
  }
  
  .v-switch {
    margin-top: 8px !important;
  }
}

@media screen and (max-width: 400px) {
  .v-list-item__title {
    font-size: 0.95rem !important;
  }
  
  .v-list-item__subtitle {
    font-size: 0.85rem !important;
  }
}
</style>
